<template>
  <div id="videoviewer">
    <div class="mb-3">
      <div class="vx-row mt-n3">
        <div class="vx-col self-center w-full">
          <div class="vx-row">
            <div class="vx-col self-center w-1/5 center-v-h">
              <p class="gen2-large-numbers text-white">{{ $route.query.lpNumber }}</p>
            </div>
            <div class="vx-col self-center w-3/5 text-left">
              
            </div>
            <div class="vx-col self-center w-1/5 center-v-h">
              <custom-svg variant="arrow" width="40" height="40" dir="down" color="white" />
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row mt-n3">
        <div class="vx-col self-center w-full">
          <div class="vx-row">
            <div class="vx-col self-center w-1/6">
              <feather-icon icon="CodesandboxIcon" class="text-white" svg-classes="stroke-current h-10 w-10"></feather-icon>
            </div>
            <div class="vx-col self-center w-5/6 text-left self-center lp-name">
              <h4 class="w-full">
                <span>{{ $route.query.lpName }}&nbsp;</span>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="url && url.includes('vimeo')">
      <div id="videoFrame"></div>
    </div>
  
    <div v-show="video.url && video.url.includes('content.digicampus.co.za')" class="player">
      <video class="video-js gen2-videojs" ref="videojs" autoplay controls></video>
    </div>

    <div  v-show="video.url && !url.includes('vimeo') && !video.url.includes('content.digicampus.co.za')" >
      <div class="overflow-hidden contentCards" :style="{ height: '100%', width: '100%'}" >
        <video class="vs-con-loading__container" ref="videoPlayerCard" id="player"  controls />
      </div>
    </div>

    <div v-show="!onlyContent" class="fab_direction-up__three-items">
      <div class="float-btn-group">
        <button class="btn-float btn-triger school-primary_gradient glow-effect_primary" @click="openActions">
          <i class="icon feather icon-more-horizontal text-white" />
        </button>
        <div class="btn-list">
          <a class="btn-float dc_dark-purple description glow-effect_dark" @click="backToTopic">
            <span class="descriptiontext">{{ topicName }}</span>
            <i class="icon feather icon-arrow-up text-white"></i>
          </a>
          <a class="btn-float dc_dark-purple description glow-effect_dark" v-show="nextTask" @click="next">
            <span class="descriptiontext">NEXT</span>
            <i class="icon feather icon-arrow-right text-white" />
          </a>
          <a class="btn-float dc_dark-purple description glow-effect_dark" v-show="prevTask" @click="previous">
            <span class="descriptiontext">PREVIOUS</span>
            <i class="icon feather icon-arrow-left text-white" />
          </a>
        </div>
      </div>
    </div>

    <div class="completebuttonstylebvideo">
      <div class="flex next_btns__container justify-center">
        <vs-button v-show="$route.query.styleB" id="completetask-btn" class="vs-con-loading__container next_btns clickbuttonactive" v-if="!isNextTaskBtnHidden"
        ref="submit_btn" icon-pack="feather" icon="icon-arrow-right" icon-after
        @click="completedNowProceed">
        Complete
        </vs-button>
      </div>
    </div>

    <vs-popup 
      title="Cannot Continue"
      id="formative-assessments-marked-popup" 
      :active.sync="isTaskBlocked">
      <p class="pb-2">Well done on completing your Formative Assessments! Your answers will be assessed by a registered Assessor. You will receive a notification regarding the outcome.</p>
      <div class="mt-3">
        <vs-button color="success" class="float-right" @click="isTaskBlocked = false">Go to Dashboard</vs-button>
      </div>
    </vs-popup>
      
  </div>
</template>

<script>
  // export
  import Player from '@vimeo/player'
  import Plyr from 'plyr';
  import videojs from 'video.js';
  import streaming  from '@videojs/http-streaming'; 
  import 'plyr/dist/plyr.css';
  import { uuid } from 'vue-uuid';
  import CustomSvg from '@/gen-2/components/CustomSVG.vue';
  export default {
    components: {
      videojs,
      streaming,
      CustomSvg
    },
    data() {
      return {
        queue: [],
        uuid: "",
        logData: {},
        fabElement: null,
        video: {},
        videoPlayer: null,
        fileExt: "",
        source: [],
        vimeoVideoId: null,
        vimeoPlayer: null,
        url: "",
        backgroundCardHeight: 0,
        backgroundCardWidth: 0,
        standaloneContentDto: {},
        onlyContent:false,
        selectedData: {},
        topicName: '',
        index: null,
        currentTask: null,
        nextTask: null,
        prevTask: null,
        navigateByChoice: false,
        isTeacher: false,
        isStudentLocal: false,
        windowWidth: window.innerWidth,
        moduleId: 0,
        isTaskBlocked: false,
        isNextTaskBtnHidden: false,
        startCourseTaskLog: false,
      };
    },
    watch:{
      isTaskBlocked: function(){
        var self = this;
        if(!self.isTaskBlocked)
        {
          self.backToDashboard();
        }
      },
      
    },
    
    methods: {
      backToTopic() {
        var self = this;
        self.navigateByChoice = false;
        if (self.$route.query.ref == "resources") {
          if (self.isTeacher) {
            self.$router.push({ name: 'TeacherResources'});
          } else if (self.isStudentLocal) {
            self.$router.push({ name: 'StudentAdditionalResources'})
          }
        } else {
          if(self.selectedData.selectedTopic && self.isTeacher)
            self.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
          else if(self.selectedData.selectedTopic && self.isStudentLocal)
            self.$router.push({ name: 'BrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
          else
            self.$router.push({ name: 'StudentRoster'});
        }
      },
      completedNowProceed(){
        var self = this;

        if (self.$acl.check('Student')) {
          var lpId = self.$route.query.moduleId;
          var lpName = self.$route.query.lpName;
          var lpNumber = self.$route.query.lpNumber;
          var selectedModule = self.$route.query.selectedTaskGroup;
          var selectedOutcome = self.$route.query.selectedOutcome;
          var timeCapture = self.$route.query.timeCapture ? JSON.parse(self.$route.query.timeCapture) : {};

          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = null;
          self.logData.taskId = self.$route.query.id;
          self.logData.toTaskId = null;

          var onSuccess = function () {
            self.destroyVideos();
            if (self.$route.query.outcome) {
              self.$router.push({ name: self.$route.name == 'PublicVideoViewer' ? "PublicOutcomeTasks" : "Gen2OutcomeTasks", query: { moduleId: lpId, lpName: lpName, lpNumber: lpNumber, selectedTaskGroup: selectedModule, selectedOutcome: selectedOutcome, timeCapture: JSON.stringify(timeCapture) } });
            } else {
              self.$router.push({ name: self.$route.name == 'PublicVideoViewer' ? "PublicStudentDashboard" : "Gen2LearningPrograms", query: { ref: "continue", id: lpId }, params: { lp: {moduleId: lpId, moduleName: lpName, lpNumber: lpNumber}, selectedTaskGroup: selectedModule } });
            }
          };
          self.$ajaxPost(self, "VideoTask/EndLogEntry", self.logData, onSuccess);
        } else {
          if (self.$route.query.outcome) {
            self.$router.push({ name: self.$route.name == 'PublicVideoViewer' ? "PublicOutcomeTasks" : "Gen2OutcomeTasks", query: { moduleId: self.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome }});
          } else {
            self.$router.push({ name: self.$route.name == 'PublicVideoViewer' ? "PublicStudentDashboard" : "Gen2LearningPrograms", query: { ref: "continue", id: lpId }, params: { lp: {moduleId: self.moduleId, moduleName: self.$route.query.lpName, number: self.$route.query.lpNumber}, selectedTaskGroup: self.$route.query.selectedTaskGroup }});
          }
        }
      },
      next() {
        var self = this;
        self.url = "";
        self.index += 1;

        var data = {
          selectedData: self.selectedData,
          standaloneContentDto: self.standaloneContentDto,
          index: self.index
        }

        localStorage.setItem("lastKnownTopic", JSON.stringify(data));

        if (self.nextTask) {
          self.closeActions();
          self.destroyVideos();

          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = self.currentTask.id;
          self.logData.toTaskId = self.nextTask.id;
          self.enqueue("VideoTask/EndLogEntry", self.logData);

          self.currentTask = self.nextTask;

          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.currentTask.id;
          self.logData.logIdentifier = self.uuid;
          self.logData.toTaskId = null;

          self.nextTask = self.index + 1 <= self.standaloneContentDto.tasks.length ? self.standaloneContentDto.tasks[self.index + 1] : null;
          self.prevTask = self.standaloneContentDto.tasks[self.index - 1];

          self.logData.fromTaskId = (self.prevTask ? self.prevTask.id : null);

          if (self.currentTask.video && self.currentTask.video.id) {
            self.navigateByChoice = false;
            self.video = self.currentTask.video;
            self.playVideo();

            self.enqueue("VideoTask/StartLogEntry", self.logData);
            
          }
          else if (self.currentTask.document && self.currentTask.document.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "DocumentViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.prevTask ? self.prevTask.id : null)
              },
              query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
            });
          }
          else if (self.currentTask.podcast && self.currentTask.podcast.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "PodcastViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.prevTask ? self.prevTask.id : null)
              },
              query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
            });
          }
          else if (self.currentTask.liveStream && self.currentTask.liveStream.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "LiveStreamViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.prevTask ? self.prevTask.id : null)
              }
            });
          }
          else if (self.currentTask.videoChat && self.currentTask.videoChat.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "VideoChatPage",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.prevTask ? self.prevTask.id : null)
              }
            });
          }
          else if (self.currentTask.upload && self.currentTask.upload.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "Gen2UploadViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.prevTask ? self.prevTask.id : null)
              }
            });
          }
        }
      },
      previous() {
        var self = this;
        self.url = "";
        self.index = --self.index;

        var data = {
          selectedData: self.selectedData,
          standaloneContentDto: self.standaloneContentDto,
          index: self.index
        }

        localStorage.setItem("lastKnownTopic", JSON.stringify(data));

        if (self.prevTask) {
          self.closeActions();
          self.destroyVideos();

          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = self.currentTask.id;
          self.logData.toTaskId = self.prevTask.id;
          self.enqueue("VideoTask/EndLogEntry", self.logData);

          self.currentTask = self.prevTask;

          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.currentTask.id;
          self.logData.logIdentifier = self.uuid;
          self.logData.toTaskId = null;

          self.nextTask = self.standaloneContentDto.tasks[self.index + 1];
          self.prevTask = self.index > 0 ? self.standaloneContentDto.tasks[self.index - 1] : null;

          self.logData.fromTaskId = (self.nextTask ? self.nextTask.id : null);

          if (self.currentTask.video && self.currentTask.video.id) {
            self.navigateByChoice = false;
            self.video = self.currentTask.video;
            self.playVideo();
            self.enqueue("VideoTask/StartLogEntry", self.logData);
          }
          else if (self.currentTask.document && self.currentTask.document.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "DocumentViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.nextTask ? self.nextTask.id : null)
              },
              query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
            });
          }
          else if (self.currentTask.podcast && self.currentTask.podcast.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "PodcastViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.nextTask ? self.nextTask.id : null)
              },
              query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
            });
          }
          else if (self.currentTask.liveStream && self.currentTask.liveStream.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "LiveStreamViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.nextTask ? self.nextTask.id : null)
              }
            });
          }
          else if (self.currentTask.videoChat && self.currentTask.videoChat.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "VideoChatPage",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.nextTask ? self.nextTask.id : null)
              }
            });
          }
          else if (self.currentTask.upload && self.currentTask.upload.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "Gen2UploadViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.nextTask ? self.nextTask.id : null)
              }
            });
            }
        }
      },
      playVideo() {
        var self = this;
        if(self.video.allowSkip)
          self.isNextTaskBtnHidden = false;
        else
          self.isNextTaskBtnHidden = true;
        if (!this.video.url.includes('m3u8')) {
          var videoUrl = self.video.url;
          if (self.video.videoTypeId == 1) {
            self.videoPlayer = new Plyr('#player', {
              autoplay: true
            });
            self.showLoadingOnElement("videoPlayerCard", 1, "material");

            var counter = 0;
            self.videoPlayer.on('canplay', event => {
              counter++;
              if (counter == 2) {
                self.$vs.loading.close(self.$refs.videoPlayerCard.$el);
              }
            });

            self.videoPlayer.on('ended', event => {
              self.isNextTaskBtnHidden = false;
            });


            self.fileExt = videoUrl.substr(videoUrl.lastIndexOf(".") + 1);
            self.source = [{ type: "video/" + self.fileExt, src: videoUrl }];
            self.videoPlayer.source = {
              type: 'video',
              sources: self.source
            };

            //self.videoPlayer.fullscreen.enter();

            document.querySelector('.plyr video').style.width = '68.2%';

            self.videoPlayer.on('enterfullscreen', event => {
              document.querySelector('.plyr video').style.width = '100%';
            });

            self.videoPlayer.on('exitfullscreen', event => {
              document.querySelector('.plyr video').style.width = '68.2%';
            });
          }
          else if (self.video.videoTypeId == 2) {
            self.vimeoVideoId = videoUrl.substr(videoUrl.lastIndexOf("/") + 1);
            self.url = "https://player.vimeo.com/video/" + self.vimeoVideoId;

            self.vimeoPlayer = new Player("videoFrame", {
              id: self.vimeoVideoId,
              width: self.backgroundCardWidth,
              height: self.backgroundCardHeight,
              autoplay: true,
              muted: false,
              gesture: 'media',
              playsinline: false,
              byline: false,
              portrait: false,
              title: false,
              speed: true,
              transparent: true,
              sidedock: false,
              referrerPolicy: null
            });
            self.vimeoPlayer.on('ended', event => {
              self.isNextTaskBtnHidden = false;
            });
          }
        } else {
          var searchMask = "/index.m3u8";
          var regEx = new RegExp(searchMask, "ig");
          var replaceMask = ".mp4";
          var player = videojs(self.$refs.videojs);
          self.videoCompleted = player;
          if (!self.video.url.includes(".mp4")){
            player.on('error', function(err) {  
              //self.$ajaxGet(self, "VideoTask/LogVideoError?error="+JSON.stringify(err) + " - " + self.video.url + " - " + JSON.stringify(player.error()),function(){});
              if(( player.error().code == 2 || player.error().code == 4) && !self.video.url.includes(".mp4")){
                setTimeout(function(){
                  self.video.url = self.video.url.replace(regEx, replaceMask);
                  player.src({ type: "video/mp4", src: self.video.url});

                  player.play();
                },1000)
              } 
            });
            
            player.ready(function(){
              this.on("ended", function(){ 
                self.isNextTaskBtnHidden = false;
              });
            });
            player.src({ type: "video/x-mpegURL", src: self.video.url });
            player.play();
            return;
          }
        }
      },
      resizeCard() {
        this.backgroundCardWidth = window.innerWidth * 0.916;
        this.backgroundCardHeight = window.innerHeight * 0.755;

        if (this.vimeoPlayer) {
          this.vimeoPlayer.element.height = this.backgroundCardHeight;
          this.vimeoPlayer.element.width = this.backgroundCardWidth;
        }
      },
      openActions(e) {
        this.fabElement = e.target.closest(".float-btn-group");
        if (this.fabElement) {
          this.fabElement.classList.toggle('open')
        }
      },
      closeActions() {
        if (this.fabElement) {
          this.fabElement.classList.remove('open')
        }
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      destroyVideos() {
        var self = this;
        if (self.videoPlayer)
          self.videoPlayer.destroy();

        if (self.vimeoPlayer)
          self.vimeoPlayer.destroy();
      },
      enqueue(messageType, logPayload) {
        this.queue.push({
          type: messageType,
          payload: {
            logIdentifier: logPayload.logIdentifier.toString(),
            toTaskId: logPayload.toTaskId,
            fromTaskId: logPayload.fromTaskId,
            taskId: logPayload.taskId,
          }
        })
      },
      dequeue() {
        return this.queue.shift();
      },
      startProcessor() {
        var self = this;
        var onSuccess = function (response) {
          var next = self.dequeue();
          if (next)
            self.process(next, onSuccess);
        };
        setInterval(function () {
          if (self.queue.length > 0) {
            self.process(self.dequeue(), onSuccess)
          }
        }, 3000)
      },
      process(queueItem, successFunc) {
        var self = this;
        if (queueItem) {
          self.$ajaxPost(self, queueItem.type, queueItem.payload, function (response) {
            successFunc();
          });
        }
      },
      getIsTaskBlocked(){
        var self = this;

        if(self.$route.query.taskClassificationTypeId == 2 && self.$acl.check("Student")){
          var studentId = localStorage.getItem("Current_User_Id");
          var onSuccess = function(response){
            self.isTaskBlocked = response.data == 2 ||  response.data == 1 ? true : false;
          } 
          self.moduleId = self.$route.query.moduleId;
          self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.moduleId, onSuccess)
        }
      },
      backToDashboard(){
        setTimeout(() => {
          this.$router.push({ name: "Gen2Learn", query: { ref: "continue" }, params: { lp: {moduleId: this.moduleId, moduleName: this.$route.query.lpName, number: this.$route.query.lpNumber}, selectedTaskGroup: this.$route.query.selectedTaskGroup, selectedOutcome: this.$route.query.selectedOutcome }});
        }, 69);
      },
    },
    beforeDestroy() {
      var self = this;
      if(self.startCourseTaskLog){
        if (!self.navigateByChoice) {
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = self.currentTask.id;
          self.logData.taskId = self.currentTask.id;
          self.logData.toTaskId = null;
          self.enqueue("VideoTask/EndLogEntry", self.logData);

          self.destroyVideos();
        }
      }
    },
    mounted() {
      this.$setColors();
      var self = this;
      self.$store.dispatch("updateTheme", "dark");
      if(self.$route.query.styleB){
        self.getIsTaskBlocked();
      }else{
        self.isTaskBlocked = false;
      }

      if(!self.isTaskBlocked){
        self.startProcessor();
        self.resizeCard();
        self.$nextTick(() => {
          window.addEventListener('resize', () => {
            self.resizeCard();
          });
        });
        
        self.isTeacher = self.$acl.check("Teacher");

        self.isStudentLocal = self.$acl.check("Student");

        if (Object.keys(self.$route.query).length != 0 && Object.keys(this.$route.params).length == 0) {
          if(self.$route.query.id){

            self.moduleId = self.$route.query.moduleId;
            localStorage.setItem("moduleId", self.moduleId);

            if(self.moduleId){
              self.currentTask = {id : self.$route.query.id};

              self.uuid = self.$uuid.v4();
              self.logData.taskId = self.currentTask.id;
              localStorage.setItem("tid", self.currentTask.id);
              self.logData.logIdentifier = self.uuid;
              self.logData.toTaskId = null;
              self.logData.fromTaskId = null;
              self.enqueue("VideoTask/StartLogEntry", self.logData);
            }
            
            if(!localStorage.getItem("userInfo")) {
              document.cookie = "autoRedirect="+ JSON.stringify({url: "VideoViewer", id: self.$route.query.id});
              window.location.replace("/login");
            }
            
            var success = (res) => {
              self.onlyContent = true;
              self.video = {};
              self.video.allowSkip = res.data.allowSkip;
              self.video.url = res.data.videoUrl;
              self.video.videoTypeId = res.data.videoTypeId;
              self.url = res.data.videoUrl;
              self.allowSkip = res.data.allowSkip;
              self.playVideo();
            };

            try{
            self.$ajaxGet(self, "Video/GetVideoByTask/" + self.$route.query.id, success);
            } catch{} 
          }
        }
        else{
          if (Object.keys(this.$route.params).length != 0) {
            self.index = self.$route.params.index;

            self.currentTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0];

            self.video = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0].video;

            if (self.$route.params.standaloneContent.tasks.length > self.index + 1)
              self.nextTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index + 1) })[0];

            if (self.index > 0)
              self.prevTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index - 1) })[0];

            self.standaloneContentDto = self.$route.params.standaloneContent;
            
            if(self.$route.params.selectedData)
              self.selectedData = self.$route.params.selectedData;

            var data = {
              selectedData: self.selectedData,
              standaloneContentDto: self.standaloneContentDto,
              index: self.index
            }

            localStorage.setItem("lastKnownTopic", JSON.stringify(data));

            if(self.selectedData.selectedTopic)
              self.topicName = self.selectedData.selectedTopic.name;
            else
              self.topicName = "Back to My Roster";

              self.playVideo();

              self.uuid = self.$uuid.v4();
              self.logData.taskId = self.currentTask.id;
              localStorage.setItem("tid", self.currentTask.id);
              self.logData.logIdentifier = self.uuid;
              self.logData.toTaskId = null;
              self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
              self.enqueue("VideoTask/StartLogEntry", self.logData);
          }
          else {
            if (self.isStudentLocal) {
              self.$router.push({ name: 'StudentRoster' });
            }
            else{
              self.$router.push({ name: 'BrowseContent' });
            }
          }
        }
      }
    
    }
  };
</script>


<style type="stylesheet">
@import "https://unpkg.com/video.js/dist/video-js.min.css";
</style>

<style lang="scss">

.next_btns__container {
  .next_btns {
    .vs-button--text {
      text-transform: uppercase !important;
    }

    .vs-icon {
      font-size: 1.2rem !important;
    }

    width: 100% !important;
  }

  #nexttask-btn {
    width: 13% !important;
    border-radius: 25px !important;
    background-image: linear-gradient(#1c80c4,  #2367a7) !important;
  }

  #completetask-btn {
    width: 225px !important;
    border-radius: 25px !important;
    background-image: linear-gradient(266deg, rgba(43,55,43,1) 0%, rgba(68,198,70,1) 78%) !important;
  }

  @media screen and (max-width: 900px) {
    #nexttask-btn {
      width: 45% !important;
    }

    #completetask-btn {
      width: 45% !important;
    }
  }

  @media screen and (max-width: 700px) {
    #nexttask-btn {
      width: 50% !important;
    }

    #completetask-btn {
      width: 50% !important;
    }
  }
}


.contentCards {
  margin: auto;
}

.plyr--video {
  text-align: -webkit-center;
  text-align: -moz-center;
  border-radius: 25px !important;
}

.fab_direction-up__three-items {
  right: 5vw;
  bottom: 4vh;
  z-index: 999;
  position: fixed;
}

.button-center-bottom{
  position:relative !important;
  top:100% !important;
  width:260px !important;
  background: rgb(43,55,43) !important;
  background: linear-gradient(266deg, rgba(43,55,43,1) 0%, rgba(68,198,70,1) 78%) !important;
  &:hover{
    cursor: pointer;
  }
}

.vx-card__body{
  padding: 0px !important;
}
  .video-js{
    width:70% !important;
    height: 60vh;
  }
  @media only screen and (max-width: 600px){
    .plyr--video {
      text-align: -webkit-center;
      text-align: -moz-center;
      border-radius: 25px !important;
      min-height: 40vh !important;   
    }
    .video-js{
      height: 50vh !important;
      width: 95vw !important;
      border-radius: 28px !important;
    }
  }

.completebuttonstylebvideo{
  padding: 2rem 0rem 0rem 0rem;
}

.gen2-videojs {
  width: 100% !important;
  max-height: 450px !important;
  aspect-ratio: 1/1 !important;

  &:not(.vjs-fullscreen) {
    border-radius: 30px !important;
    overflow: hidden !important;
    border: 3px solid white !important;

    .vjs-control-bar {
      border-radius: 0 0 30px 30px !important;
    }
  }
}

</style>
